import { render, staticRenderFns } from "./Expenditure.vue?vue&type=template&id=b3d69a70"
import script from "./Expenditure.vue?vue&type=script&lang=js"
export * from "./Expenditure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports